<template>
    <base-layout page-title="View Reservations" whiteBackground removeMode>
        <div
            style="
                position: fixed;
                z-index: 99;
                width: 100%;
                background: white;
                box-shadow: 0px 1px 5px 0px rgba(194, 194, 194, 1);
            "
        >
            <div
                style="
                    width: 100%;
                    display: flex;
                    flex-wrap: wrap;
                    overflow-x: auto !important;
                    overflow-y: hidden;
                    padding-left: 10px;
                    padding-right: 10px;
                    height: 53px;
                "
                class="ion-nowrap"
            >
                <ion-select class="filter-button" v-model="timeframe" placeholder="Select Timeframe">
                    <ion-select-option value="Yesterday">Yesterday</ion-select-option>
                    <ion-select-option value="Today">Today</ion-select-option>
                    <ion-select-option value="Last Week">Last Week</ion-select-option>
                    <ion-select-option value="This Week">This Week</ion-select-option>
                    <ion-select-option value="Last Month">Last Month</ion-select-option>
                    <ion-select-option value="This Month">This Month</ion-select-option>
                    <ion-select-option value="Last Year">Last Year</ion-select-option>
                    <ion-select-option value="This Year">This Year</ion-select-option>
                    <ion-select-option value="Future">Future</ion-select-option>
                </ion-select>

                <ion-select class="filter-button" v-model="showType" placeholder="Select Type">
                    <ion-select-option value="Reservation">Reservations</ion-select-option>
                    <ion-select-option value="Block">Blocks</ion-select-option>
                    <ion-select-option value="All">All</ion-select-option>
                </ion-select>

                <ion-select
                    v-if="showType != 'Block'"
                    class="filter-button"
                    v-model="filterStatus"
                    placeholder="Select Status"
                >
                    <ion-select-option value="All">All Statuses</ion-select-option>
                    <ion-select-option value="PAID">Paid/Paid In Full</ion-select-option>
                    <ion-select-option value="PAIDDEPOSIT">Confirmed</ion-select-option>
                    <ion-select-option value="NOTPAID">Unconfirmed</ion-select-option>
                    <ion-select-option value="CANCELLED">Cancelled</ion-select-option>
                </ion-select>

                <ion-select
                    v-if="showType != 'Block'"
                    class="filter-button"
                    v-model="filterPet"
                    placeholder="Select Filter"
                >
                    <ion-select-option value="NoPet">No Pets</ion-select-option>
                    <ion-select-option value="Pet">Has Pets</ion-select-option>
                    <ion-select-option value="All">No Pet Filter</ion-select-option>
                </ion-select>

                <ion-button class="filter-button" color="primary" @click="showSearch()" v-if="!isSearch" mode="ios"
                    >Open Search</ion-button
                >
                <ion-button class="filter-button" color="primary" @click="showSearch()" v-if="isSearch" mode="ios"
                    >Close</ion-button
                >
                <ion-button class="filter-button" color="primary" @click="resetFilters()" mode="ios"
                    >Reset Filters</ion-button
                >
            </div>
            <div v-if="isSearch" style="display: flex; align-items: center">
                <ion-searchbar
                    mode="ios"
                    :debounce="0"
                    @ionInput="searchChange($event)"
                    placeholder="Search"
                ></ion-searchbar>
                <ion-button
                    class="filter-button"
                    color="primary"
                    @click="hideKeyboard()"
                    v-if="isSearch && getPlatform() != 'web'"
                    >Hide Keyboard</ion-button
                >
            </div>
        </div>

        <div v-if="isSearch" style="margin-top: 40px">
            <ion-label style="color: transparent">Hi from Bobby!</ion-label>
        </div>

        <div style="margin-top: 75px">
            <template v-for="(item, index) in reservationList" :key="index">
                <div v-if="searchMatch(item)" lines="none" style="max-width: 500px; margin: auto">
                    <!--
                        Reservation Card
                    -->
                    <div v-if="matchFilter(item) && item.state != 'BLOCKED'">
                        <ion-card
                            mode="ios"
                            @click="openControlPanelModal(item.id)"
                            style="margin: 10px; margin-bottom: 15px; margin-top: 15px; cursor: pointer"
                        >
                            <ion-card-content style="padding: 0px; margin: 5px">
                                <ion-item style="height: 35px" lines="none" class="ion-no-padding">
                                    <ion-label
                                        text-wrap
                                        style="font-weight: 700; padding-left: 20px; font-size: medium"
                                        >{{ item.guest.full_name }}</ion-label
                                    >

                                    <div
                                        v-if="item.state == 'PAID' && item.substate == 'PAID'"
                                        data-v-4262366e=""
                                        title="Paid In Full"
                                        class="reservation-status-marker mr-2"
                                        style="background: rgb(0, 153, 0)"
                                        slot="end"
                                    ></div>
                                    <div
                                        v-if="item.state == 'PAID' && item.substate != 'PAID'"
                                        data-v-4262366e=""
                                        title="Paid"
                                        class="reservation-status-marker mr-2"
                                        style="background: rgb(0, 153, 0)"
                                        slot="end"
                                    ></div>

                                    <div
                                        v-if="item.state == 'PAIDDEPOSIT'"
                                        data-v-4262366e=""
                                        title="Confirmed"
                                        class="reservation-status-marker mr-2"
                                        style="
                                            background: linear-gradient(
                                                transparent 0%,
                                                transparent 50%,
                                                rgb(255, 170, 0) 50%,
                                                rgb(255, 170, 0) 100%
                                            );
                                            border: 2px solid rgb(255, 170, 0);
                                        "
                                        slot="end"
                                    ></div>
                                    <div
                                        v-if="item.state == 'NOTPAID'"
                                        data-v-4262366e=""
                                        title="Unconfirmed"
                                        class="reservation-status-marker mr-2"
                                        style="border: 2px solid rgb(204, 0, 0)"
                                        slot="end"
                                    ></div>
                                    <div
                                        v-if="item.state == 'CANCELLED'"
                                        data-v-4262366e=""
                                        title="Cancelled"
                                        class="reservation-status-marker mr-2"
                                        style="background: rgb(158, 158, 158); border-radius: 0px"
                                        slot="end"
                                    ></div>
                                </ion-item>

                                <ion-item lines="none">
                                    <div slot="start" style="margin-inline-end: 0px" v-if="item.properties.length > 0">
                                        <img
                                            v-if="!item.properties[0].thumbnail_url && item.properties.length == 1"
                                            style="width: 100px; height: 40px"
                                            src="@/assets/icons/home-outline.svg"
                                        />
                                        <img
                                            v-if="item.properties[0].thumbnail_url && item.properties.length == 1"
                                            style="width: 100px; border-radius: 10px"
                                            :src="item.properties[0].thumbnail_url"
                                        />
                                        <img
                                            v-if="item.properties.length > 1"
                                            style="width: 100px; border-radius: 10px"
                                            src="@/assets/icons/multi-property-icon.png"
                                        />
                                    </div>
                                    <div slot="start" v-if="item.properties.length <= 0">
                                        <img style="width: 100px; height: 40px" src="@/assets/icons/home-outline.svg" />
                                    </div>
                                    <ion-list slot="end" style="width: 100%; margin-bottom: 10px">
                                        <div
                                            style="font-weight: 700; font-size: small; padding-left: 15px"
                                            text-wrap
                                            v-for="(list, index) in item.properties"
                                            :key="index"
                                        >
                                            {{ list.name }}
                                        </div>
                                        <div v-if="item.state == 'PAIDDEPOSIT'">
                                            <p style="font-weight: 500; font-size: small; padding-left: 15px" text-wrap>
                                                {{ item.booking_method_name }} ·
                                                <span style="color: rgb(255, 170, 0)">Confirmed</span>
                                            </p>
                                        </div>
                                        <div v-if="item.state == 'PAID' && item.substate == 'PAID'">
                                            <p style="font-weight: 500; font-size: small; padding-left: 15px" text-wrap>
                                                {{ item.booking_method_name }} ·
                                                <span style="color: rgb(0, 153, 0)">Paid In Full</span>
                                            </p>
                                        </div>
                                        <div v-if="item.state == 'PAID' && item.substate != 'PAID'">
                                            <p style="font-weight: 500; font-size: small; padding-left: 15px" text-wrap>
                                                {{ item.booking_method_name }} ·
                                                <span style="color: rgb(0, 153, 0)">Paid</span>
                                            </p>
                                        </div>
                                        <div v-if="item.state == 'NOTPAID'">
                                            <p style="font-weight: 500; font-size: small; padding-left: 15px" text-wrap>
                                                {{ item.booking_method_name }} ·
                                                <span style="color: rgb(204, 0, 0)">Unconfirmed</span>
                                            </p>
                                        </div>
                                        <div v-if="item.state == 'CANCELLED'">
                                            <p style="font-weight: 500; font-size: small; padding-left: 15px" text-wrap>
                                                {{ item.booking_method_name }} ·
                                                <span style="color: rgb(113, 113, 113)">Cancelled</span>
                                            </p>
                                        </div>
                                        <div style="padding-left: 2px" class="ldx-quick-amenities">
                                            <div class="ldx-quick-amenity">
                                                <img src="@/assets/icons/calendar.svg" />
                                                <span>{{ formatDate(item.from_date) }}</span>
                                            </div>
                                            <div class="ldx-quick-amenity">
                                                <img src="@/assets/icons/moon.svg" />
                                                <span>{{ item.nights }}</span>
                                            </div>
                                            <div class="ldx-quick-amenity">
                                                <img src="@/assets/icons/guest-icon.png" />
                                                <span>{{ item.guests + item.children }}</span>
                                            </div>
                                            <div v-if="item.properties[0]">
                                                <div
                                                    class="ldx-quick-amenity"
                                                    v-if="item.properties[0].number_of_pets > 0"
                                                >
                                                    <img src="@/assets/icons/pet-icon.png" />
                                                    <span>{{ item.properties[0].number_of_pets }}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </ion-list>
                                </ion-item>
                            </ion-card-content>
                        </ion-card>
                    </div>

                    <!--
                        Blocking Card
                    -->
                    <div v-if="matchFilter(item) && item.state == 'BLOCKED'">
                        <ion-card mode="ios" style="margin: 10px; margin-bottom: 15px; margin-top: 15px">
                            <ion-card-content style="padding: 0px; margin: 5px">
                                <ion-item style="height: 35px" lines="none" class="ion-no-padding">
                                    <ion-label text-wrap style="font-weight: 700; padding-left: 20px"
                                        >{{ formatDate(item.from_date) }} - {{ formatDate(item.to_date) }}</ion-label
                                    >
                                </ion-item>

                                <ion-item lines="none">
                                    <ion-icon
                                        style="width: 75px; margin-bottom: 10px"
                                        color="medium"
                                        :src="closeCircle"
                                    ></ion-icon>
                                    <ion-list style="width: 100%; margin-bottom: 10px">
                                        <p
                                            style="font-weight: 700; font-size: medium; padding-left: 15px; color: red"
                                            text-wrap
                                        >
                                            BLOCKED
                                        </p>
                                        <p
                                            style="font-weight: 500; font-size: small; padding-left: 15px"
                                            text-wrap
                                            v-if="item.properties[0]"
                                        >
                                            {{ item.properties[0].name }}
                                        </p>
                                    </ion-list>
                                </ion-item>
                            </ion-card-content>
                        </ion-card>
                    </div>
                </div>
            </template>
        </div>
        <div v-if="total <= 0">
            <ion-card>
                <ion-card-content>
                    <p
                        class="ion-text-center"
                        style="font-family: 'San Francisco', sans-serif; font-size: large; font-weight: 500"
                    >
                        No Results
                    </p>
                </ion-card-content>
            </ion-card>
        </div>
        <div
            v-if="total > 0"
            style="
                position: fixed;
                bottom: 0;
                z-index: 99;
                width: 100%;
                display: flex;
                flex-wrap: nowrap;
                overflow-x: auto !important;
                overflow-y: hidden;
                background: white;
                box-shadow: 0px -1px 5px 0px rgba(194, 194, 194, 1);
            "
            class="ion-nowrap"
        >
            <ion-label
                v-if="showType != 'All' && total == 1"
                style="font-size: larger; margin: auto; margin-bottom: 20px; margin-top: 5px"
                >Total: {{ total }} {{ showType }}</ion-label
            >
            <ion-label
                v-if="showType != 'All' && total != 1"
                style="font-size: larger; margin: auto; margin-bottom: 20px; margin-top: 5px"
                >Total: {{ total }} {{ showType }}s</ion-label
            >

            <ion-label
                v-if="showType == 'All' && total == 1"
                style="font-size: larger; margin: auto; margin-bottom: 20px; margin-top: 5px"
                >Total: {{ total }} Reservation & Block</ion-label
            >
            <ion-label
                v-if="showType == 'All' && total != 1"
                style="font-size: larger; margin: auto; margin-bottom: 20px; margin-top: 5px"
                >Total: {{ total }} Reservations & Blocks</ion-label
            >
        </div>
        <div style="margin-bottom: 100px"></div>
    </base-layout>
</template>

<script lang="ts">
    import { useIonRouter } from '@ionic/vue';
    import { defineComponent, onMounted, ref, watch } from 'vue';
    import {
        informationCircleOutline,
        searchOutline,
        mailOutline,
        callOutline,
        chatboxEllipsesOutline,
        homeSharp,
        person,
        moon,
        calendar,
        closeCircle,
        book,
        searchCircle,
        options,
        receipt,
    } from 'ionicons/icons';
    import AppAPI from '@/services/AppAPI';
    import { format, sub, add } from 'date-fns';
    import { showLoading, hideLoading } from '@/services/Loading';
    import { errorToast } from '@/services/Toast';
    import { Keyboard } from '@capacitor/keyboard';
    import { Capacitor } from '@capacitor/core';
    import ModalController from '@/services/ModalController';

    export default defineComponent({
        components: {},
        setup() {
            var date = format(new Date(), 'MM/dd/yyyy');
            const ionRouter = useIonRouter();
            const reservationList = ref();
            const timeframe = ref('Future');
            const showType = ref('Reservation');
            const filterStatus = ref('All');
            const total = ref(0);
            const isSearch = ref(false);
            const searchValue = ref('');
            const filterPet = ref('All');

            const openControlPanelModal = async (reservationId: string) => {
                await ModalController.controlPanelModal(reservationId);
            };

            const getReservations = async () => {
                const loadingService = await showLoading('Loading...');
                try {
                    var calcTimeframe = {
                        fromDateString: '',
                        toDateString: '',
                    };
                    var fromDate, toDate;

                    if (timeframe.value == 'Today') {
                        fromDate = new Date();
                        calcTimeframe.fromDateString = format(fromDate, 'yyyy-MM-dd');
                        calcTimeframe.toDateString = format(fromDate, 'yyyy-MM-dd');
                    } else if (timeframe.value == 'Yesterday') {
                        fromDate = sub(new Date(), { days: 1 });
                        calcTimeframe.fromDateString = format(fromDate, 'yyyy-MM-dd');
                        toDate = sub(new Date(), { days: 1 });
                        calcTimeframe.toDateString = format(toDate, 'yyyy-MM-dd');
                    } else if (timeframe.value == 'Last Week') {
                        fromDate = sub(new Date(), { weeks: 1 });
                        calcTimeframe.fromDateString = format(fromDate, 'yyyy-MM-dd');
                        toDate = new Date();
                        calcTimeframe.toDateString = format(toDate, 'yyyy-MM-dd');
                    } else if (timeframe.value == 'This Week') {
                        fromDate = new Date();
                        calcTimeframe.fromDateString = format(fromDate, 'yyyy-MM-dd');
                        toDate = add(new Date(), { weeks: 1 });
                        calcTimeframe.toDateString = format(toDate, 'yyyy-MM-dd');
                    } else if (timeframe.value == 'Last Month') {
                        fromDate = new Date();
                        fromDate = sub(new Date(fromDate.getFullYear(), fromDate.getMonth(), 1), { months: 1 });
                        calcTimeframe.fromDateString = format(fromDate, 'yyyy-MM-dd');
                        toDate = add(fromDate, { months: 1 });
                        calcTimeframe.toDateString = format(toDate, 'yyyy-MM-dd');
                    } else if (timeframe.value == 'This Month') {
                        fromDate = new Date();
                        fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth(), 1);
                        calcTimeframe.fromDateString = format(fromDate, 'yyyy-MM-dd');
                        toDate = add(fromDate, { months: 1 });
                        calcTimeframe.toDateString = format(toDate, 'yyyy-MM-dd');
                    } else if (timeframe.value == 'Last Year') {
                        fromDate = new Date();
                        fromDate = sub(new Date(fromDate.getFullYear(), 0, 1), { years: 1 });
                        calcTimeframe.fromDateString = format(fromDate, 'yyyy-MM-dd');
                        toDate = add(fromDate, { years: 1 });
                        calcTimeframe.toDateString = format(toDate, 'yyyy-MM-dd');
                    } else if (timeframe.value == 'This Year') {
                        fromDate = new Date();
                        fromDate = new Date(fromDate.getFullYear(), 0, 1);
                        calcTimeframe.fromDateString = format(fromDate, 'yyyy-MM-dd');
                        toDate = add(fromDate, { years: 1 });
                        calcTimeframe.toDateString = format(toDate, 'yyyy-MM-dd');
                    } else {
                        fromDate = new Date();
                        calcTimeframe.fromDateString = format(fromDate, 'yyyy-MM-dd');
                        toDate = add(new Date(), { years: 5 });
                        calcTimeframe.toDateString = format(toDate, 'yyyy-MM-dd');
                    }

                    var response = AppAPI.getReservationsList(calcTimeframe.fromDateString, calcTimeframe.toDateString);
                    response
                        .then((value) => {
                            reservationList.value = value.data;
                            reservationList.value.sort(function (a: any, b: any) {
                                if (a.state == 'BLOCKED') {
                                    return 1;
                                }
                                if (b.state == 'BLOCKED') {
                                    return -1;
                                }
                                return 0;
                            });

                            calcTotal();
                            hideLoading(loadingService);
                        })
                        // eslint-disable-next-line @typescript-eslint/no-unused-vars
                        .catch(async (error) => {
                            hideLoading(loadingService);
                            errorToast('Error loading reservations');
                        });
                } catch (error) {
                    hideLoading(loadingService);
                    errorToast('Error loading reservations');
                }
            };

            const formatDate = (date: string) => {
                let tmpDateArray = date.split('-');
                if (tmpDateArray.length <= 1) {
                    return date;
                }
                const month = tmpDateArray[1];
                const day = tmpDateArray[2];
                const year = tmpDateArray[0];

                let fromDateString = month + '/' + day + '/' + year;

                return fromDateString;
            };

            const calcTotal = () => {
                total.value = 0;
                for (let i = 0; i < reservationList.value.length; i++) {
                    if (matchFilter(reservationList.value[i])) {
                        total.value += 1;
                    }
                }
            };

            const showSearch = () => {
                isSearch.value = !isSearch.value;
                searchValue.value = '';
            };

            const searchMatch = (item: any) => {
                if (searchValue.value != '' && isSearch.value) {
                    if (item.guest.full_name.toLowerCase().includes(searchValue.value.toLowerCase())) {
                        return true;
                    }
                    if (item.guest.email.toLowerCase().includes(searchValue.value.toLowerCase())) {
                        return true;
                    }
                    for (let i = 0; i < item.properties.length; i++) {
                        if (item.properties[i]) {
                            if (item.properties[i].name.toLowerCase().includes(searchValue.value.toLowerCase())) {
                                return true;
                            }
                        }
                    }
                    if (item.id.toString().includes(searchValue.value.toLowerCase())) {
                        return true;
                    }
                    if (item.booking_method_name.toLowerCase().includes(searchValue.value.toLowerCase())) {
                        return true;
                    }
                } else {
                    return true;
                }

                return false;
            };

            const searchChange = (event: any) => {
                const query = event.target.value.toLowerCase();
                searchValue.value = query;
                calcTotal();
            };

            const hideKeyboard = () => {
                Keyboard.hide();
            };

            const getPlatform = () => {
                return Capacitor.getPlatform();
            };

            const matchFilter = (item: any) => {
                if (searchMatch(item) || searchValue.value == '') {
                    if (filterPet.value == 'NoPet') {
                        for (let i = 0; i < item.properties.length; i++) {
                            if (item.properties[i].number_of_pets > 0) {
                                return false;
                            }
                        }
                    } else if (filterPet.value == 'Pet') {
                        let hasPet = false;
                        for (let i = 0; i < item.properties.length; i++) {
                            if (item.properties[i].number_of_pets > 0) {
                                hasPet = true;
                            }
                        }
                        if (!hasPet) {
                            return false;
                        }
                    }
                    if (showType.value == 'All') {
                        if (filterStatus.value == 'All') {
                            return true;
                        } else if (item.state == filterStatus.value) {
                            return true;
                        }
                    } else if (showType.value == 'Reservation' && item.state != 'BLOCKED') {
                        if (filterStatus.value == 'All') {
                            return true;
                        } else if (item.state == filterStatus.value) {
                            return true;
                        }
                    } else if (showType.value == 'Block' && item.state == 'BLOCKED') {
                        return true;
                    }
                }
                return false;
            };

            const resetFilters = () => {
                timeframe.value = 'Future';
                showType.value = 'Reservation';
                filterStatus.value = 'All';
                filterPet.value = 'All';
                searchValue.value = '';
                isSearch.value = false;
            };

            onMounted(() => {
                getReservations();
            });

            watch(
                () => timeframe.value,
                () => {
                    getReservations();
                }
            );

            watch(
                () => showType.value,
                () => {
                    calcTotal();
                }
            );

            watch(
                () => filterStatus.value,
                () => {
                    calcTotal();
                }
            );

            watch(
                () => filterPet.value,
                () => {
                    calcTotal();
                }
            );

            return {
                date,
                ionRouter,
                informationCircleOutline,
                searchOutline,
                mailOutline,
                callOutline,
                chatboxEllipsesOutline,
                homeSharp,
                person,
                moon,
                calendar,
                closeCircle,
                book,
                searchCircle,
                options,
                receipt,
                reservationList,
                timeframe,
                showType,
                filterStatus,
                total,
                isSearch,
                searchValue,
                filterPet,
                openControlPanelModal,
                getReservations,
                formatDate,
                calcTotal,
                showSearch,
                searchMatch,
                searchChange,
                hideKeyboard,
                getPlatform,
                matchFilter,
                resetFilters,
            };
        },
    });
</script>

<style scoped>
    .filter-button {
        background: #20469b;
        margin: 5px;
        border-radius: 5px;
        box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
        color: white;
        font-size: 15px;
        font-weight: 500;
        font-family: 'San Francisco', sans-serif;
        height: 44px;
        width: 100%;
        padding-left: 10px;
        padding-right: 10px;
    }
    ion-select::part(icon) {
        color: white;
    }
</style>
